import { render } from "./MainChuongTrinhTaiTro.vue?vue&type=template&id=56de3d43"
import script from "./MainChuongTrinhTaiTro.vue?vue&type=script&lang=js"
export * from "./MainChuongTrinhTaiTro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__